import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useModalStore = create(
  persist(
    (set, get) => ({
      modalToOpen: [''],
      setModalToOpen: (modal) =>
        set((state) => ({
          modalToOpen: [modal], // Update modalToOpen explicitly
        })),
    }),
    {
      name: 'modal',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
